export const capitalizeString = str => {
  return str && str[0].toUpperCase() + str.slice(1);
};
